export default {
  productFeatures: [],
  productFeature: undefined,
};
